import { useRouter } from 'next/router'
import React from 'react'

import { WorkTabPanelProps } from '@/components/domain/works'
import { useWebViewMode } from '@/hooks/useWebViewMode'
import { useGetWorkDetail } from '@/usecases'

export const useWorkDetails = () => {
  const router = useRouter()
  const { uuid } = router.query
  const projectName =
    router.query.projectName === 'making' ? '制作裏側' : '本編'
  const isWebViewMode = useWebViewMode({})

  const { data: workDetail = {} } = useGetWorkDetail(uuid as string, false)

  const mainStoryProject = React.useMemo(() => {
    return workDetail.projects?.filter(p => p.name === '本編').find(() => true)
  }, [workDetail])

  const mainStoryProjectSeason = React.useMemo(() => {
    return mainStoryProject?.seasons?.[0]
  }, [mainStoryProject])

  const makingStoryProject = React.useMemo(() => {
    return workDetail.projects
      ?.filter(p => p.name === '制作裏側')
      .find(() => true)
  }, [workDetail])

  const makingStoryProjectSeason = React.useMemo(() => {
    return makingStoryProject?.seasons?.[0]
  }, [makingStoryProject?.seasons])

  const workTitleProps = React.useMemo((): { workDetailName: string } => {
    return {
      workDetailName: workDetail.name ?? '',
    }
  }, [workDetail])

  const waitFreeCount = React.useMemo(() => {
    return (mainStoryProjectSeason?.episodes ?? []).reduce((acc, season) => {
      if (season.isWaitFree) {
        return (acc += 1)
      }
      return acc
    }, 0)
  }, [mainStoryProjectSeason])

  const mainTabPanelProps = React.useMemo((): Omit<
    WorkTabPanelProps,
    'isMain'
  > => {
    return {
      episodes: mainStoryProjectSeason?.episodes ?? [],
      creators: mainStoryProjectSeason?.creators ?? [],
      description: mainStoryProjectSeason?.description ?? '',
      waitFreeCount,
      introImageUrl: mainStoryProjectSeason?.introImageUrl ?? '',
    }
  }, [mainStoryProjectSeason, waitFreeCount])

  const makingTabPanelProps = React.useMemo((): Omit<
    WorkTabPanelProps,
    'isMain'
  > => {
    return {
      episodes: makingStoryProjectSeason?.episodes ?? [],
      creators: makingStoryProjectSeason?.creators ?? [],
      description: makingStoryProjectSeason?.description ?? '',
      waitFreeCount,
      introImageUrl: makingStoryProjectSeason?.introImageUrl ?? '',
    }
  }, [makingStoryProjectSeason, waitFreeCount])

  return {
    uuid,
    workTitleProps,
    mainTabPanelProps,
    mainStoryProjectSeason,
    makingTabPanelProps,
    makingStoryProjectSeason,
    workDetail,
    mainStoryProject,
    makingStoryProject,
    isWebViewMode,
    projectName,
  }
}
